import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsvUploadComponent } from './csv-upload/csv-upload.component';
import { CsvMappingComponent } from './csv-mapping/csv-mapping.component';
import { CsvSaverComponent } from './csv-saver/csv-saver.component';
import { AngularMaterialModule } from '../../module/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicTableModule } from '../../../dynamic-table/dynamic-table.module';

@NgModule({
  declarations: [CsvUploadComponent, CsvMappingComponent, CsvSaverComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule, FormsModule,
    MatProgressBarModule,
    TranslateModule,
    DynamicTableModule
  ],
  exports: [CsvUploadComponent, CsvMappingComponent, CsvSaverComponent]
})
export class CsvModule { }